import { render, staticRenderFns } from "./verify-skills.vue?vue&type=template&id=4ae00654&scoped=true"
import script from "./verify-skills.vue?vue&type=script&lang=js"
export * from "./verify-skills.vue?vue&type=script&lang=js"
import style0 from "./verify-skills.vue?vue&type=style&index=0&id=4ae00654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae00654",
  null
  
)

export default component.exports